// The upcoming list: next 14 days grouped by day ("Today", "Tomorrow", then dates) (SPEC §7.9).

import type { MyLesson } from "../../api/types";
import { addDays } from "../../dates";
import { formatLongDate, t } from "../../i18n/i18n";
import { createElement } from "../../ui/dom";
import { buildMyLessonCard } from "./myLessonCard";

export function buildMyScheduleList(lessons: MyLesson[], today: string): HTMLElement {
  const list: HTMLDivElement = createElement("div");
  if (lessons.length === 0) {
    list.append(createElement("p", "muted", t("mySchedule.nothing")));
    return list;
  }

  const dates: string[] = [...new Set(lessons.map((lesson: MyLesson): string => lesson.key.date))];
  for (const date of dates) {
    const day: HTMLElement = createElement("section", "schedule-day");
    day.append(createElement("h2", "", describeDay(date, today)));
    for (const lesson of lessons.filter((item: MyLesson): boolean => item.key.date === date)) {
      day.append(buildMyLessonCard(lesson));
    }

    list.append(day);
  }

  return list;
}

function describeDay(date: string, today: string): string {
  if (date === today) {
    return `${t("app.today")} — ${formatLongDate(date)}`;
  }

  if (date === addDays(today, 1)) {
    return `${t("app.tomorrow")} — ${formatLongDate(date)}`;
  }

  return formatLongDate(date);
}
